import Reflux from 'reflux';

const SingleNodeActions = Reflux.createActions({
  'get': {asyncResult: true},
});

export default SingleNodeActions;



// WEBPACK FOOTER //
// ./src/actions/nodes/SingleNodeActions.js